module.exports = __webpack_public_path__ + "static/TheMetSans-RegularItalic-c610ef51571be65b940cf161e21531e7.woff";